import { Injectable, NgModule } from '@angular/core';
import { InputComponent } from './component/input/input.component';
import { DatepickerDateTimePickerIntlService } from './service/datepicker-date-time-picker-intl.service';
import { LabelComponent } from './component/label/label.component';
import { CommonModule } from '@angular/common';
import { NumericDirective } from './directive/numeric.directive';
import { NumericDecimalDirective } from './directive/numeric-decimal.directive';
import {
  SelectFooterTemplateDirective, SelectHeaderTemplateDirective,
  SelectItemLabelDirective,
  SelectLabelTemplateDirective, SelectLoadingSpinnerTemplateDirective, SelectLoadingTextTemplateDirective,
  SelectMultiLabelTemplateDirective, SelectNotFoundTemplateDirective,
  SelectOptgroupTemplateDirective,
  SelectOptionTemplateDirective, SelectTagTemplateDirective, SelectTypeToSearchTemplateDirective
} from './directive/select-templates.directive';
import { InputTrimDirective } from './directive/input-trim.directive';
import { CutDirective } from './directive/cut.directive';
import { PhoneMaskDirective } from './directive/phone-mask.directive';
// import { PhoneMaskSecondDirective } from './directive/phone-mask-second.directive';
import { ControlErrorsComponent } from './component/control-errors/control-errors.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TooltipComponent } from './component/tooltip/tooltip.component';

/**
 * Изменение названия кнопок для плагина ng-pick-datetime
 */
@Injectable()
export class DefaultIntl extends DatepickerDateTimePickerIntlService {
  /** A label for the cancel button */
  override cancelBtnLabel = 'Отмена';

  /** A label for the set button */
  override setBtnLabel = 'Выбрать';

  override rangeFromLabel = 'От';

  override rangeToLabel = 'До';
}

@NgModule({
    declarations: [
        // SelectComponent,
        // RadioComponent,
        // TextareaComponent,
        // CheckboxComponent,
        // CheckboxComponent,
        // SignSelectorComponent,
        // TimezoneComponent,
        // PageHeaderComponent,
        // InfoComponent,
        // LegendComponent,
        // TableComponent,
        InputComponent,
        // InputNumericDecimalComponent,
        TooltipComponent,
        // CaptchaComponent,
        // LoaderComponent,
        // InfoListComponent,
        // DatepickerComponent,
        InputTrimDirective,
        LabelComponent,
        NumericDirective,
        NumericDecimalDirective,
        CutDirective,
        // AutocompleteComponent,
        // BreadcrumbsComponent,
        // UploadFileComponent,
        // FileComponent,
        // UploadFileCollectionComponent,
        // ObliqueTabComponent,
        // LinearTabComponent,
        // LiIconComponent,
        // CardComponent,
        // CardHeaderComponent,
        // CardBodyComponent,
        // CardFooterComponent,
        // ListComponent,
        // ListItemComponent,
        PhoneMaskDirective,
        // PhoneMaskSecondDirective,
        // UserDatePipe,
        // NumericPipe,
        // SectionFileComponent,
        // SectionUploadFileComponent,
        // SectionUploadFileCollectionComponent,
        // DocumentFlowFileCollectionComponent,
        // DocumentFlowFileListComponent,
        // QrCodeComponent,
        // RecaptchaValueAccessorDirective,
        // DatepickerDialogContainerComponent,
        // DatepickerCalendarBodyComponent,
        // DatepickerCalendarMonthViewComponent,
        // DatepickerCalendarMultiYearViewComponent,
        // DatepickerCalendarYearViewComponent,
        // DatepickerCalendarComponent,
        // DatepickerTimerBoxComponent,
        // DatepickerNumberFixedLengthPipe,
        // DatepickerTimerComponent,
        // DatepickerDateTimePickerContainerComponent,
        // DatepickerDateTimeInlineComponent,
        // DatepickerDateTimePickerInputDirective,
        // DatepickerDateTimePickerComponent,
        // DatepickerDateTimePickerTriggerDirective,
        // SelectDropdownPanelComponent,
        // SelectOptionComponent,
        SelectItemLabelDirective,
        SelectOptionTemplateDirective,
        SelectOptgroupTemplateDirective,
        SelectLabelTemplateDirective,
        SelectMultiLabelTemplateDirective,
        SelectHeaderTemplateDirective,
        SelectFooterTemplateDirective,
        SelectNotFoundTemplateDirective,
        SelectTypeToSearchTemplateDirective,
        SelectLoadingTextTemplateDirective,
        SelectTagTemplateDirective,
        SelectLoadingSpinnerTemplateDirective,
        // UploadFileCollectionElementComponent,
        // CarouselComponent,
        // EditorElementComponent,
        // RequestSharedViewDocumentComponent,
        // DownloadFileDirective,
        ControlErrorsComponent,
        // AddFileButtonContainerComponent,
        // AddFileButtonComponent,
        // UploadCollectionContainerComponent,
        // UploadCollectionComponent,
        // CountComponent,
        // RangeComponent,
        // FromDateTimePipe,
        // IconComponent,
        // PreviewAndDownloadLinkComponent,
        // FinancialServicesComponent,
        // BannerSliderComponent,
        // ColoredBannerComponent,
        // SimpleBarComponent,
        // AntiDumpingMeasuresIconComponent,
        // WarningIconComponent,
        // PCalendarComponent,
        // DoubleInputComponent,
        // BadgeComponent,
        // RequestProvisionTooltipComponent,
        // AdditionalChecksComponent,
    ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    // A11yModule,
    // OverlayModule,
    // PortalModule,
    // FormsModule,
    // ReactiveFormsModule,
    // RouterModule,
    // MatProgressBarModule,
    // MatTreeModule,
    // MatSelectModule,
    // MatTooltipModule,
    // MatMenuModule,
    ],
    exports: [
        //   SelectComponent,
        //   TextareaComponent,
        //   RadioComponent,
        //   CheckboxComponent,
        //   CheckboxComponent,
        //   SignSelectorComponent,
        //   TimezoneComponent,
        //   PageHeaderComponent,
        //   InfoComponent,
        //   LegendComponent,
        //   TableComponent,
        InputComponent,
        //   InputNumericDecimalComponent,
        //   CaptchaComponent,
        //   LoaderComponent,
        //   InfoListComponent,
        //   DatepickerComponent,
        //   InputTrimDirective,
        //   CutDirective,
        //   TooltipComponent,
        //   LabelComponent,
        //   NumericDirective,
        //   NumericDecimalDirective,
        //   AutocompleteComponent,
        //   BreadcrumbsComponent,
        //   UploadFileComponent,
        //   FileComponent,
        //   UploadFileCollectionComponent,
        //   ObliqueTabComponent,
        //   LinearTabComponent,
        //   LiIconComponent,
        //   LinearTabComponent,
        //   CardComponent,
        //   CardHeaderComponent,
        //   CardBodyComponent,
        //   CardFooterComponent,
        //   ListComponent,
        //   ListItemComponent,
        //   PhoneMaskDirective,
        //   PhoneMaskSecondDirective,
        //   UserDatePipe,
        //   NumericPipe,
        //   SectionFileComponent,
        //   SectionUploadFileComponent,
        //   SectionUploadFileCollectionComponent,
        //   DocumentFlowFileCollectionComponent,
        //   DocumentFlowFileListComponent,
        //   QrCodeComponent,
        //   RecaptchaValueAccessorDirective,
        //   UploadFileCollectionElementComponent,
        //   CarouselComponent,
        //   EditorElementComponent,
        //   RequestSharedViewDocumentComponent,
        //   ControlErrorsComponent,
        //   RangeComponent,
        //   DownloadFileDirective,
        //   CountComponent,
        //   ControlErrorsComponent,
        //   FromDateTimePipe,
        //   IconComponent,
        //   PreviewAndDownloadLinkComponent,
        //   SimpleBarComponent,
        //   DatepickerDateTimePickerTriggerDirective,
        //   FinancialServicesComponent,
        //   BannerSliderComponent,
        //   ColoredBannerComponent,
        //   AntiDumpingMeasuresIconComponent,
        //   WarningIconComponent,
        //   PCalendarComponent,
        //   DoubleInputComponent,
        //   BadgeComponent,
        //   RequestProvisionTooltipComponent,
        //   AdditionalChecksComponent,
    ],
  providers: [
  ],
})
export class FormElementRenderModule {}
